import { GestureResponderEvent, Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import { Icon, IconName } from '@/components/Icon';
import { useResponsiveHeight } from '@/components/Util/reactResponsiveDimensions';
import colors from '@/config/colors';
import OfflineImage from '@/components/SharedComponents/OfflineImage/OfflineImage';
import React from 'react';

interface ExerciseCardProps {
  onPress: (e: GestureResponderEvent) => void;
  iconName?: IconName;
  imageSrc?: number | { uri: string };
  label: string;
  isActive: boolean;
}

export function ExerciseCard({
  onPress,
  iconName,
  imageSrc,
  label,
  isActive,
}: ExerciseCardProps) {
  const responsiveFontHeight = useResponsiveHeight(2);
  const getResponsiveFontSize = (factor: number) => {
    return responsiveFontHeight * factor;
  };

  const responsizeIconSize = getResponsiveFontSize(4);
  const responsizeIconSizeBig = getResponsiveFontSize(7.5);
  const responsizeFontSize = getResponsiveFontSize(1.5);

  function handlePressCard(e: GestureResponderEvent) {
    onPress(e);
  }

  return (
    <Pressable
      testID={label}
      onPress={handlePressCard}
      className="w-full h-full p-3"
    >
      <View className="bg-white h-full w-full rounded-3xl ">
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            padding: responsizeIconSize,
          }}
        >
          {!!imageSrc && (
            <OfflineImage source={imageSrc} className="w-full flex-1" />
          )}

          {!!iconName && (
            <Icon
              name={iconName}
              size={responsizeIconSizeBig}
              color={colors.darkGrey}
            />
          )}
        </View>
        <View className="p-2 absolute bottom-2 left-0 right-0">
          <Text
            numberOfLines={2}
            style={{
              fontSize: responsizeFontSize,
              textAlign: 'center',
            }}
          >
            {label}
          </Text>
        </View>

        <View
          style={{
            position: 'absolute',
            top: responsizeFontSize / 3,
            right: responsizeFontSize / 3,
          }}
        >
          <Icon
            name={isActive ? 'checkboxCircleMarked' : 'checkboxCircleUnmarked'}
            size={responsizeIconSize}
            color={isActive ? colors.primary : colors.darkGrey}
          />
        </View>
      </View>
    </Pressable>
  );
}

export default React.memo(ExerciseCard);
